import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { decodeBlurHash } from './blurhash.js';

var _excluded = ["hash", "width", "height", "animateOut"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fadeOut = /*#__PURE__*/keyframes({
  '0%': {
    opacity: 1
  },
  '100%': {
    opacity: 0
  }
});
var ImagePreviewStyled = /*#__PURE__*/styled.canvas.withConfig({
  displayName: "ImagePreview__ImagePreviewStyled",
  componentId: "sc-zm5nyy-0"
})(function (props) {
  return _objectSpread(_objectSpread({}, props.$css), {}, {
    opacity: 1
  });
}, function (props) {
  return props.$animateOut ? css(["animation:", " 0.3s ease-out;"], fadeOut) : undefined;
});

/** ImagePreview displays blur image placeholder using BlurHash when the image is loading. */
var ImagePreview = function ImagePreview(props) {
  var hash = props.hash,
    width = props.width,
    height = props.height,
    animateOut = props.animateOut,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hidden = _React$useState2[0],
    setHidden = _React$useState2[1];
  var canvasRef = React.useRef(null);
  React.useEffect(function () {
    var canvas = canvasRef.current;
    if (canvas) {
      var canvasWidth = canvas.offsetWidth;
      var canvasHeight = canvas.offsetHeight;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      var pixels = decodeBlurHash(hash, canvasWidth, canvasHeight);
      var context = canvas.getContext('2d');
      if (context) {
        var imageData = context.createImageData(canvasWidth, canvasHeight);
        imageData.data.set(pixels);
        context.putImageData(imageData, 0, 0);
      }
    }
  }, [hash]);
  var onAnimationEnd = function onAnimationEnd() {
    var canvas = canvasRef.current;
    if (canvas) {
      canvas.style.display = 'none';
      setHidden(true);
    }
  };
  return /*#__PURE__*/React.createElement(ImagePreviewStyled, _extends({
    ref: canvasRef,
    $animateOut: animateOut,
    $css: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: width,
      height: height
    },
    onAnimationEnd: onAnimationEnd,
    role: "img",
    "aria-hidden": hidden
  }, rest));
};
ImagePreview.defaultProps = {
  animateOut: false
};
var ImagePreviewMemoized = /*#__PURE__*/React.memo(ImagePreview);
ImagePreview.displayName = 'ImagePreview';

export { ImagePreviewMemoized as ImagePreview };
//# sourceMappingURL=ImagePreview.js.map
